import { useReadContract } from "wagmi";

const useGetApproved = (address, abi, tokenId, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "getApproved",
    args: [tokenId],
    provider: provider
  });
};

export default useGetApproved;
